module.exports = __webpack_public_path__ + "static/media/4.2134c627.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/4.png
// module id = 493
// module chunks = 0